import { TaskCard } from '@medely/ui-kit';
import React from 'react';
import { config } from '@mp/config';
import { useProNavigate } from '@mp/contexts';
import { TaskCardLayout } from '../../TaskCard';
import { DxGyCampaignContainerProps } from './interface';

export const DxGyCampaignContainer = ({ title, body }: DxGyCampaignContainerProps) => {
  const { openUrl } = useProNavigate();
  const onClick = () => openUrl(config.help.limitedTimeIncentiveProgram);

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'circle-dollar-to-slot', color: 'primary' }}
        title={title}
        body={body}
        onClick={onClick}
      />
    </TaskCardLayout>
  );
};
